import { combineReducers } from "redux";
import { objectsSlice } from "../app/reduxSlices/objectsSlice";

export const sportReducer = combineReducers({
  salon: objectsSlice({ name: "salon" }).reducer,
  sport: objectsSlice({ name: "sport" }).reducer,
  closet: objectsSlice({ name: "closet" }).reducer,
  contract: objectsSlice({ name: "contract" }).reducer,
  sans_category: objectsSlice({ name: "sans_category" }).reducer,
  sans_time: objectsSlice({ name: "sans_time" }).reducer,
  sans_time_selectedSport: objectsSlice({ name: "sans_time_selectedSport" }).reducer,
  sans_time_selectedWeekDay: objectsSlice({ name: "sans_time_selectedWeekDay" }).reducer,
  weekDay: objectsSlice({ name: "weekDay" }).reducer,
  subGroupSansPermissions: objectsSlice({ name: "subGroupSansPermissions" }).reducer,
  subGroupDeviceSportPermissions: objectsSlice({ name: "subGroupDeviceSportPermissions" }).reducer,
  sportSubGroupPriceSetting: objectsSlice({ name: "sportSubGroupPriceSetting" }).reducer,
  sport_payment: objectsSlice({ name: "sport_payment" }).reducer,
  bankAccountSalons: objectsSlice({ name: "bankAccountSalons" }).reducer,
  contractSports: objectsSlice({ name: "contractSports" }).reducer,
  sportUsersReport: objectsSlice({ name: "sportUsersReport" }).reducer,
  sportManageReservations: objectsSlice({ name: "sportManageReservations" }).reducer,
  sportMyReservations: objectsSlice({ name: "sportMyReservations" }).reducer,

});
